var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MonitoringStatCardBlock',{attrs:{"definition":_vm.definition,"data":_vm.data,"urgency":_vm.urgency,"always-clickable":true,"loading":_vm.loading},on:{"drill":function($event){return _vm.$emit('drill', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }